module.exports = __webpack_public_path__ + "media/yolo-3.0/Previos-fc5ad151.svg";